type CareerOfferVisibility = {
	isIntersecting: boolean;
	intersectionRatio: number;
};

type CareerOfferImpressionTrackerOptions = {
	schedule: (callback: () => void) => number;
	cancel: (timer: number) => void;
	emit: () => void;
};

export const createCareerOfferImpressionTracker = ({
	schedule,
	cancel,
	emit,
}: CareerOfferImpressionTrackerOptions) => {
	let pendingTimer: number | null = null;
	let emitted = false;

	const cancelPending = () => {
		if (pendingTimer === null) return;
		cancel(pendingTimer);
		pendingTimer = null;
	};

	return {
		update({ isIntersecting, intersectionRatio }: CareerOfferVisibility) {
			if (emitted) return;
			if (!isIntersecting || intersectionRatio < 0.5) {
				cancelPending();
				return;
			}
			if (pendingTimer !== null) return;

			const timer = schedule(() => {
				if (pendingTimer !== timer || emitted) return;
				pendingTimer = null;
				emitted = true;
				emit();
			});
			pendingTimer = timer;
		},
		dispose() {
			cancelPending();
		},
	};
};
